import styled from 'styled-components'

import PageTopTitle from "../../components/shared/PageTopTitle"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"

import Button from '../../components/shared/button/Btn'
import { showModal } from '../../features/modal/modalSlice'
import { getBlockedUsers } from '../../features/blockedUsers/blockedUserSlice'
import EngellenenAraclarContainer from '../../components/singlePageContainers/EngellenenAraclarContainer'
import InputText from '../../components/shared/input/new/InputText'
import InputSelect from '../../components/shared/input/new/InputSelect'
import useWindowDimensions from '../../hooks/useWindowSize'
import EngellenenAraclarContainerMobile from '../../components/singlePageContainers/EngellenenAraclarContainerMobile'

const Container = styled.div`

width: 100%;

    .wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 30px;

        .content{
          display: flex;
          flex-direction: column;
          align-items: center;

            .top-container{
              width: 100%;
              display: flex;
              justify-content: space-between;
              margin: 10px 0;
              .filters{
                display: flex;
                align-items: center;
                gap: 15px;
              }
              }
              .titles {
                width: 100%;
                display: grid;
                grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
                gap: 15px;
                padding-inline: 10px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                text-align: center;
                color: ${({ theme }) => theme.mainTextColor};
              }
            }
        }

        .pagination-container{
            gap: 60px;
            margin: 0 30px;
            margin-top: 20px;
            height: 200px;
        }
`

const titles = ["Telefon", "Adı Soyadı", "TC NO", "Plaka", "Gerekçe-Açıklama-Not", "Listeye Kayıt Tarihi"]

const FirmaKaraListesi = () => {
    const {theme} = useSelector((state) => state.layout)
    const [isMoreActive, setIsMoreActive] = useState(null)
    const dispatch = useDispatch()
    const {blockedUserList} = useSelector((state) => state.blockedUsers)
    const {windowDimensions} = useWindowDimensions()

    useEffect(() => {
      dispatch(getBlockedUsers())
    }, [])
    
  return (
    <Container theme={theme}>
      <PageTopTitle title={"Engellenen Sürücüler"} position="sticky"/>

      <div className="wrapper">
          <div className="content">
            <div className="top-container">
              <div className="filters">
                {/* <InputText data={companyName} setData={(e) => setCompanyName(e.target.value)} labelText='Firma Adı' inputWidth={"100%"} />
                <InputSelect data={isKamyoon?.text} setData={setIsKamyoon} initialOptions={filterKamyoonData} labelText='Kamyoon Mu Engelledi?' inputWidth={"100%"} /> */}
              </div> 
              <Button handleClick={()=>dispatch(showModal("firmaKaraListeEkle"))} bgColor="transparent" width="150px" color="#E85446">Ekle</Button>
            </div>
            {windowDimensions?.width > 850 &&
              <div className="titles">
                {titles.map((item) => (
                  <p>{item}</p>
                ))}
              </div>
            }

            {windowDimensions?.width < 850 ? 
              blockedUserList?.map((item) => (
                <EngellenenAraclarContainerMobile isMoreActive={isMoreActive} setIsMoreActive={setIsMoreActive} data={item} />
              ))
            :
              blockedUserList?.map((item) => (
                <EngellenenAraclarContainer isMoreActive={isMoreActive} setIsMoreActive={setIsMoreActive} data={item} />
              ))
            }
            
          </div>
          <div className="pagination-container">
              
          </div>
      </div>
    </Container>
  )
}

export default FirmaKaraListesi